exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".level-1{border:3px solid #fff}.level-2{border:3px solid #000}.level-3{border:3px solid #0004ff}.level-4{border:3px solid red}.level-5{border:3px solid #ff0}.level-6{border:3px solid green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/players/playerProfile/playerProfile.scss
// module id = 828
// module chunks = 0